"use strict";

(function () {
    jQuery(document).ready(function () {
        let current_hash = window.location.hash;
        if(current_hash == '#subscribe'){
            $('#succ-subscribe').show();
            $('#form-subscribe').hide();
        }
    });
})(jQuery);